import { put, call } from "redux-saga/effects";
import axios from "../../../config/AxiosConfig";
import { CF3_QUESTIONNAIRE_API } from "../../actions/apiCollections";
import {
  getCf3ListStart,
  getCf3ListFail,
  getCf3ListSuccess,
  getCf3DetailSuccess,
} from "../../actions/cf3Questionnaire/cf3QuestionnaireActions";

export function* getCf3ListSaga(action) {
  yield put(getCf3ListStart());
  try {
    const response = yield axios.get(CF3_QUESTIONNAIRE_API + "admin", {
      params: {
        ...(action?.search?.search !== "" && {
          search: action?.search?.search,
        }),
        // status may legitimately be 0 (under review), so only skip empty string
        ...(action?.search?.status !== "" && {
          status: action?.search?.status,
        }),
        limit: 10 * action.pageLimit,
      },
    });
    yield put(getCf3ListSuccess(response.data?.data));
  } catch (error) {
    yield put(getCf3ListFail(error));
  }
}

export function* getCf3DetailSaga(action) {
  try {
    const response = yield axios.get(
      CF3_QUESTIONNAIRE_API + action.id + "/admin"
    );
    yield put(getCf3DetailSuccess(response.data?.data));
  } catch (error) {
    yield put(getCf3ListFail(error));
  }
}

export function* cf3StatusActionSaga(action) {
  try {
    yield axios.patch(
      CF3_QUESTIONNAIRE_API + action.cf3Data.id + "/admin",
      action.cf3Data
    );
    yield call(getCf3DetailSaga, { id: action.cf3Data.id });
  } catch (error) {
    yield put(getCf3ListFail(error));
  }
}
